import {
  AffectedStaffEndOfStayReport,
  AffectedStaffEndOfStayReportInput
} from '../../lib/types/models/affectedStaff/affected-staff-end-of-stay-report'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function saveAffectedStaffEndOfStayReport(data: {
  input: AffectedStaffEndOfStayReportInput
  affectedStaffId: number
}) {
  const { affectedStaffId: id, input } = data

  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.saveAffectedStaffEndOfStayReport.url, { id }))
    .post<AffectedStaffEndOfStayReport>(input)
}
